// Function that takes a value and returns true if the value is not empty, otherwise it returns 'Required.' Used for form validation.
export function requiredRule(value: string) {
    if (value && !!value.trim()) return true;
    return "Required.";
}
